import { NavLink, Outlet, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Printer } from 'lucide-react';

const reportTabs = [
  { path: 'trial-balance', label: 'Neraca saldo' },
  { path: 'pl', label: 'Laba rugi' },
  { path: 'balance-sheet', label: 'Neraca' },
  { path: 'cash-flow', label: 'Arus kas' },
  { path: 'journal-register', label: 'Daftar jurnal' },
  { path: 'ledger', label: 'Buku besar' },
  { path: 'compare', label: 'Bandingkan' },
];

function subTabClass(active) {
  return `shrink-0 rounded-lg px-3 py-2 text-xs font-semibold transition-colors sm:text-sm ${
    active
      ? 'bg-[#2D6CDF]/15 text-[#2D6CDF] ring-1 ring-[#2D6CDF]/30'
      : 'text-slate-600 hover:bg-slate-100'
  }`;
}

export default function AccountingReportsLayout() {
  return (
    <div className="accounting-reports-print space-y-5">
      <div className="no-print flex flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Laporan</p>
          <h2 className="text-lg font-bold text-slate-900">Pilih laporan</h2>
          <p className="text-xs text-slate-500">Ekspor CSV/PDF tersedia di masing-masing halaman.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button type="button" variant="outline" size="sm" asChild>
            <Link to="/dashboard/finance-reports">Finance Reports</Link>
          </Button>
          <Button type="button" variant="outline" size="sm" onClick={() => window.print()}>
            <Printer className="mr-1 h-4 w-4" />
            Cetak halaman
          </Button>
        </div>
      </div>

      <nav
        className="no-print flex flex-wrap gap-1.5 rounded-2xl border border-slate-200 bg-slate-50/80 p-2 shadow-inner"
        aria-label="Jenis laporan"
      >
        {reportTabs.map(({ path, label }) => (
          <NavLink key={path} to={path} className={({ isActive }) => subTabClass(isActive)}>
            {label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
